'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

interface ParagraphProps {
  children?: React.ReactNode;
  innerHtml?: string;
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
}

export function Paragraph({ children, innerHtml, className, ref }: ParagraphProps) {
  if (innerHtml) {
    return (
      <HtmlRendererRaw
        ref={ref}
        className={cn(
          'text-sm text-muted-foreground sm:text-base',
          'ea-paragraph__inner-html',
          className,
        )}
        html={innerHtml}
      />
    );
  }

  return (
    <p
      className={cn(
        'text-sm font-normal text-muted-foreground sm:text-base',
        'ea-paragraph',
        className,
      )}
    >
      {children}
    </p>
  );
}
